export const HELP_LINK = "https://www.luxedo.com/pages/help"
